import { StripeTokenResponse } from "components/StripePaymentForm/StripePaymentForm";
import { isDev } from "config/env";
import { resetBuyFlow } from "features/slices/buyFlowSlice";
import { SignupChargeDetails } from "features/types";
import { useCallback } from "react";
import ReactGA from "react-ga4";
import { useAppDispatch } from "../useAppDispatch";
import { useAppSelector } from "../useAppSelector";
import conversionFunctions from "./conversionFunctions";

const generateRandomId = () => {
  return Math.random().toString(36).slice(2);
};

function useSendConversionData() {
  const { tenantSubdomain } = useAppSelector((state) => state.tenant);
  const dispatch = useAppDispatch();

  const sendConversionData = useCallback(function (
    signupCharge: SignupChargeDetails | null,
    totalQuantity: number,
    billingToken?: StripeTokenResponse,
  ) {
    if (signupCharge && !isDev && tenantSubdomain) {
      const totalCharge =
        parseFloat(signupCharge.signupCharge) +
        signupCharge.remainingMonths * parseFloat(signupCharge.recurringCharge);

      const transactionId = generateRandomId();
      // send purchase event to FanRally GA4
      // Send a custom event
      ReactGA.event("purchase", {
        value: totalCharge,
        currency: "USD",
        transaction_id: transactionId,
        quantity: totalQuantity,
      });
      // send conversion tracking data to tenant as well
      const conversionFunction = conversionFunctions[tenantSubdomain!];
      conversionFunction &&
        conversionFunction(totalCharge, totalQuantity, transactionId);
      dispatch(resetBuyFlow());
    }
  }, []);

  return sendConversionData;
}

export default useSendConversionData;
